/**
 * EliorGroup.Joyfood.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Days } from './days';


export interface UpdateHubCommand { 
    id: number;
    name?: string | null;
    cdpf: string;
    address?: string | null;
    stockDay?: Days;
    stockControl: number;
}
export namespace UpdateHubCommand {
}


